import { ActionType, createReducer } from "typesafe-actions";
import { OfflineMode } from "types";
import * as actions from "./actions";

const initialState: OfflineMode = {
  isOnline: navigator.onLine,
  assignments: [],
  swStatus: "activating",
  downloading: false,
  status: "",
  loading: false,
};

type OfflineModeActions = ActionType<typeof actions>;

const reducer = createReducer<OfflineMode, OfflineModeActions>(initialState)
  .handleAction(actions.setIsOnline, (state, { payload: newIsOnline }) => ({
    ...state,
    isOnline: newIsOnline,
  }))
  .handleAction(
    actions.addCachedAssignment,
    (state, { payload: newAssignment }) => {
      const assignments = state.assignments.filter(
        (assignment) => assignment.id !== newAssignment.id,
      );

      return {
        ...state,
        assignments: [...assignments, newAssignment],
      };
    },
  )
  .handleAction(
    actions.addCachedAssignments,
    (state, { payload: newAssignments }) => ({
      ...state,
      assignments: [...state.assignments, ...newAssignments],
    }),
  )
  .handleAction(actions.deleteCachedAssignment, (state, { payload: id }) => ({
    ...state,
    assignments: state.assignments.filter((assignment) => assignment.id !== id),
  }))
  .handleAction(actions.deleteAllCachedAssignment, (state) => ({
    ...state,
    assignments: [],
  }))
  .handleAction(actions.setSwStatus, (state, { payload: status }) => ({
    ...state,
    swStatus: status,
  }))
  .handleAction(actions.setDownloading, (state, { payload: downloading }) => ({
    ...state,
    downloading,
  }))
  .handleAction(actions.setLoading, (state, { payload: loading }) => ({
    ...state,
    loading,
  }))
  .handleAction(actions.setStatus, (state, { payload: status }) => ({
    ...state,
    status,
  }));

export default reducer;
